import { __ } from '../functions/commom';
import { useAppState } from '../state/StateContext';
import Button from './base/Button';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  errorPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px',
    width: '100%',
  },
  errorButton: {
    marginTop: '20px',
  },
});

function ErrorPage() {
  const classes = useStyles();
  const state = useAppState();
  return (
    <div className={classes.errorPage}>
      {state?.errorMessage?.get() || 'Something went wrong'}
      <Button theme="primary" className={classes.errorButton} href="/">
        {__('Back to home')}
      </Button>
    </div>
  );
}

export default ErrorPage;
